import { Flex, Text, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

interface ChartInfoProps {
  titulo: string;
  valor: string;
  corValor: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}

/**
 * Caixa de total ao lado do gráfico, igual à ChartInfo do DashboardCEO do
 * Analytics (lá ela é local da página). O clique é opcional: no donut de
 * Situação ela leva para a Conciliação.
 */
const ChartInfo: React.FC<ChartInfoProps> = ({
  titulo,
  valor,
  corValor,
  icon,
  onClick,
}) => {
  const bg = useColorModeValue('gray.100', 'gray.900');
  const hover = useColorModeValue('gray.200', 'gray.700');

  return (
    <Flex
      as={onClick ? 'button' : 'div'}
      onClick={onClick}
      textAlign="left"
      flexDir="column"
      justify="space-between"
      bg={bg}
      borderWidth="2px"
      p="4"
      rounded="2xl"
      flex="1"
      w="100%"
      _hover={onClick ? { bg: hover } : undefined}
    >
      <Flex justify="space-between" w="100%" gridGap="2">
        <Text fontWeight="medium" fontSize="0.9rem">
          {titulo}
        </Text>
        {icon}
      </Flex>
      <Text fontSize="md" color={corValor} fontWeight="medium">
        {valor}
      </Text>
    </Flex>
  );
};

export default ChartInfo;
